export function loadDataList(source, targetId) {
  fetch(`/mockdata/${source}.json`)
      .then((res) => res.json())
      .then((json) => {
          if(json.result.match(/ok/i)) {
            const target = document.getElementById(targetId);
            if(!target) return;
            
            while(target.lastChild) target.removeChild(target.lastChild);

            json.data.forEach(value => {
              const opt = document.createElement('option');
              opt.textContent = value;

              target.appendChild(opt);
            });
          }
      });
}
